module.exports = __webpack_public_path__ + "img/Ndaytrip_footer.de6ae2e5.png";